<template>
  <van-popup
    v-model="addproshow"
    v-if="addproshow"
    class="edit-box"
    :style="{ width: '80%' }"
  >
    <div class="frm-area">
      <div class="title">我的商品</div>
      <div class="frm-box">
        <van-form @submit="onSubmit">
          <div class="frm-item">
            <div class="frm-label">商品图图片</div>
            <div
              style="padding: 16px 16px; max-height: 200px; overflow-y: auto"
            >
              <van-uploader
                v-model="fileList1"
                multiple
                :after-read="afterRead1"
                :max-count="10"
                :before-read="beforeRead"
                :before-delete="file1Delete1"
              >
              </van-uploader>
              <div v-if="islogo" style="color: #ee0a24; font-size: 12px">
                请上传商品图片
              </div>
            </div>
          </div>
          <div class="frm-item">
            <div class="frm-label">商品名称</div>
            <van-field
              v-model="frm.name"
              placeholder="请填写商品名称"
              :rules="[{ required: true, message: '请填写商品名称' }]"
            />
          </div>
          <div class="frm-item">
            <div class="frm-label">起拍卖价</div>
            <van-field
              v-model="frm.starting_price"
              placeholder="请填写起拍卖价"
              :rules="[{ required: true, message: '请填写起拍卖价' }]"
            />
          </div>
          <div class="frm-item">
            <div class="frm-label">商品描述</div>
            <van-field
              v-model="frm.bewrite"
              type="textarea"
              placeholder="请填写商品描述"
              rows="10"
              autosize
            />
          </div>
          <div class="btn-box">
            <van-button
              native-type="submit"
              :loading="posting"
              loading-text="提交中..."
              style="background-color: #141423; color: #fff; border-radius: 8px"
              >保存商品信息</van-button
            >
          </div>
        </van-form>
      </div>
    </div>
  </van-popup>
</template>

<script>
import Axios from 'axios'
import { getToken } from '@/utils/cookies'
export default {
  name: 'AddProductView',
  data () {
    return {
      addproshow: true,
      posting: false,
      islogo: false,
      fileList1: [],
      frm: {
        logo: null,
        name: null,
        starting_price: null,
        bewrite: null,
        carousel: null
      }
    }
  },
  methods: {
    async onSubmit () {
      if (this.posting) {
        return
      }
      this.posting = true

      await this.$http({
        method: 'post',
        url: 'addShopProduct',
        data: this.frm
      })
        .then(res => {
          this.$toast.success(res.msg)
          this.posting = false
          this.$emit('refresh-proinfo')
          this.addproshow = false
        })
        .catch(() => {
          this.posting = false
        })
    },
    beforeRead (file) {
      this.isUploadfront = false
      this.isUploadback = false
      const validTypes = [
        'image/jpeg',
        'image/png',
        'image/gif',
        'image/webp',
        'image/bmp',
        'image/svg+xml',
        'image/apng',
        'image/avif'
      ]
      if (!validTypes.includes(file.type)) {
        this.$toast.fail('请上传图片文件')
        return false
      }
      return true
    },
    async afterRead1 (file) {
      file.status = 'uploading'
      const formData = new FormData()
      formData.append('file', file.file)
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: 'bearer ' + getToken()
        }
      }
      await Axios.post('/api/index/tools.tools/upload', formData, config)
        .then(response => {
          if (response.data.code == 200) {
            file.status = ''
          } else {
            file.status = 'failed'
            this.$toast.fail(response.data.msg)
          }
        })
        .catch(error => {
          file.status = 'failed'
          console.log(error)
        })
    },
    file1Delete1 (item, index) {
      console.log(index)
      this.fileList1 = this.removeByIndex(this.fileList1, index.index)
    },
    removeByIndex (arr, index) {
      if (index < 0 || index >= arr.length) {
        console.warn(`下标 ${index} 超出数组范围 [0, ${arr.length - 1}]`)
        return arr
      }
      arr.splice(index, 1)
      return arr
    }
  }
}
</script>
<style lang="scss" scoped>
.edit-box {
  padding: 15px 12px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.3);
  .frm-area {
    .title {
      height: 38px;
      line-height: 38px;
      font-size: 18px;
      font-weight: 550;
      border-bottom: 1px solid #dcdee0;
    }
    .frm-box {
      margin: 8px 0;
      .frm-label {
        text-indent: 14px;
        font-size: 14px;
        margin-top: 10px;
      }
      .btn-box {
        margin: 16px 0 0;
        text-align: right;
      }
    }
  }
}
</style>
